module.exports = __webpack_public_path__ + "static/media/5ed79c4172f4e5e57a748786.fde37682.png";